/* eslint-disable no-use-before-define */
import React from 'react'

export default ({label=''}={}) => <React.Fragment>
    <div className='vertical-offset-sm'></div>
    <div
    className="text-muted text-right">
    Showing only {label} since 2011
    </div>

    </React.Fragment>


// WEBPACK FOOTER //
// ./src/bond-detail/events/foot.js